







import WarnPage from '@/components/WarnPage/WarnPage.vue'
import Vue from 'vue'
export default Vue.extend({
  components: {WarnPage}
})
